import { ICopyable } from '../core/copyable.interface';
import { IIdentifiable } from '../core/identifiable.interface';
import { DocumentFlux } from '../enums/document-flux';
import { DocumentType } from '../enums/document-type';
import { Attachment } from './attachment';

/**
 * Represente un document d'un dossier
 */
export class FolderDocument implements ICopyable<FolderDocument>, IIdentifiable {
    _id: any;

    get id(): any {
        return this._id;
    }

    set id(value: any) {
        this._id = value;
    }

    organizationId: string;

    folderId: string;

    flux: DocumentFlux;

    type: DocumentType;

    from: string;

    to: string;

    label: string;

    subject: string;

    comment: string;

    body: string;

    creationDate: Date;

    updatedDate: Date;

    originalDate: Date;

    isDelete: boolean;

    isRead: boolean;

    attachments: Attachment[] = [];

    /**
     * Propriété propre au web
     */
    viewId: number = null;

    public createCopy(): FolderDocument {
        const instance = new FolderDocument();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.folderId = this.folderId;
        instance.flux = this.flux;
        instance.type = this.type;
        instance.from = this.from;
        instance.to = this.to;
        instance.label = this.label;
        instance.subject = this.subject;
        instance.comment = this.comment;
        instance.body = this.body;
        instance.creationDate = this.creationDate;
        instance.updatedDate = this.updatedDate;
        instance.originalDate = this.originalDate;
        instance.isDelete = this.isDelete;
        instance.isRead = this.isRead;
        instance.viewId = this.viewId;
        instance.attachments = Attachment.fromArray(this.attachments);

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.folderId = other.folderId;
        this.flux = other.flux;
        this.type = other.type;
        this.from = other.from;
        this.to = other.to;
        this.label = other.label;
        this.subject = other.subject;
        this.comment = other.comment;
        this.body = other.body;
        this.creationDate = other.creationDate;
        this.updatedDate = other.updatedDate;
        this.originalDate = other.originalDate;
        this.isDelete = other.isDelete;
        this.isRead = other.isRead;
        this.viewId = other.viewId;
        this.attachments = Attachment.fromArray(other.attachments);
    }

    public static fromJson(other: any): FolderDocument {
        const instance = new FolderDocument();
        instance.id = other.id;
        instance.organizationId = other.organizationId;
        instance.folderId = other.folderId;
        instance.flux = other.flux;
        instance.type = other.type;
        instance.from = other.from;
        instance.to = other.to;
        instance.label = other.label;
        instance.subject = other.subject;
        instance.comment = other.comment;
        instance.body = other.body;
        instance.creationDate = other.creationDate;
        instance.updatedDate = other.updatedDate;
        instance.originalDate = other.originalDate;
        instance.isDelete = other.isDelete;
        instance.isRead = other.isRead;
        instance.viewId = other.viewId;
        instance.attachments = Attachment.fromArray(other.attachments);
        return instance;
    }

    /**
     * Retourne un tableau d'instances de FolderDocument à partir d'un tableau JSON.
     * @param other : Tableau d'instances de IFolder.
     * @returns : Tableau d'instances de Folder.
     */
    public static fromArray(others: any[]) {
        if (!!others) {
            let documents: FolderDocument[] = [];

            others.forEach((x) => {
                const document = FolderDocument.fromJson(x);
                documents.push(document);
            });

            return documents;
        } else {
            return null;
        }
    }
}
